/**
 * Hotfix for CKEditor 5 Balloon Panels inside scaled or overflow-constrained containers.
 * Fixes panels pushed to -99999px and prevents overlapping when multiple balloons open simultaneously.
 */
export const ckEditorBalloonPositioning = (editor) => {
    var _a, _b;
    if (!((_b = (_a = editor === null || editor === void 0 ? void 0 : editor.editing) === null || _a === void 0 ? void 0 : _a.view) === null || _b === void 0 ? void 0 : _b.document))
        return;
    editor.editing.view.document.on('selectionChange', () => {
        requestAnimationFrame(() => {
            // Fetch all currently visible balloon panels (excluding the "Powered by" badge)
            const allPanels = Array.from(document.querySelectorAll('.ck-balloon-panel_visible')).filter((p) => !p.classList.contains('ck-powered-by-balloon'));
            if (allPanels.length === 0)
                return;
            const editableEl = editor.ui.getEditableElement();
            if (!editableEl)
                return;
            const rect = editableEl.getBoundingClientRect();
            // Base coordinates for positioning the primary balloon right above the editor
            const baseTop = Math.max(10, rect.top - 50);
            const baseLeft = Math.max(10, rect.left);
            allPanels.forEach((panel) => {
                const currentLeft = parseInt(panel.style.left, 10);
                const isCorrupted = currentLeft <= -90000 || isNaN(currentLeft);
                if (isCorrupted) {
                    // Check if another properly positioned panel already occupies the target spot
                    const isSpaceOccupied = allPanels.some((otherPanel) => {
                        if (otherPanel === panel)
                            return false;
                        const otherTop = parseInt(otherPanel.style.top, 10);
                        return Math.abs(otherTop - baseTop) < 35;
                    });
                    // Stack the panel one level higher (-45px) if the primary spot is occupied (e.g., by the table toolbar)
                    const targetTop = isSpaceOccupied ? baseTop - 45 : baseTop;
                    panel.style.top = `${targetTop}px`;
                    panel.style.left = `${baseLeft}px`;
                }
            });
        });
    });
};
